import { render, staticRenderFns } from "./ManagementRemoveDocumentPlaceholder.vue?vue&type=template&id=37b03071"
import script from "./ManagementRemoveDocumentPlaceholder.vue?vue&type=script&lang=ts"
export * from "./ManagementRemoveDocumentPlaceholder.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37b03071')) {
      api.createRecord('37b03071', component.options)
    } else {
      api.reload('37b03071', component.options)
    }
    module.hot.accept("./ManagementRemoveDocumentPlaceholder.vue?vue&type=template&id=37b03071", function () {
      api.rerender('37b03071', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/skeletonPlaceholder/components/ManagementRemoveDocumentPlaceholder.vue"
export default component.exports